<template>
  <transition name="fade">  
    <div class='message' v-show="show">
      <span>{{ text }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'message',
  props: {
    text: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables.scss';
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.message {
  position: absolute; //用绝对定位，transform函数不会出现元素宽度为奇数时字体模糊的问题
  left: 50%;
  top: 50%;
  display: inline-table;
  margin-right: 64px; //实际呈现的效果：和页面左、右侧各有64/2px的间距
  transform: translate(-50%, -50%);
  padding: 10px 15px;
  border-radius: 5px;
  line-height: 1.4;
  font-size: $font-size-normal;
  background: rgba(0,0,0,.7);
  color: #fff;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/message/message.vue